import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_header",
  class: "header py-4",
  "data-kt-sticky": "true",
  "data-kt-sticky-name": "header",
  "data-kt-sticky-offset": "{default: '200px', lg: '300px'}"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "d-flex align-items-stretch justify-content-between mb-2" }
const _hoisted_4 = { class: "d-flex align-items-center gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-arrow-left-circle-fill fs-3 text-dark",
  alt: "Вернуться"
}, null, -1)
const _hoisted_6 = { class: "d-flex align-items-center text-dark fw-bolder my-0 fs-5 fs-lg-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-plus-circle fs-3 text-dark",
  alt: "Создать"
}, null, -1)
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "ms-1 ms-lg-6" }
const _hoisted_10 = {
  class: "btn btn-icon btn-sm btn-active-bg-accent",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_11 = { class: "svg-icon svg-icon-1 svg-icon-dark" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  id: "kt_aside_toggler",
  class: "btn btn-icon btn-sm btn-active-bg-accent d-lg-none ms-1 ms-lg-6"
}
const _hoisted_14 = { class: "svg-icon svg-icon-1 svg-icon-dark" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Dropdown1 = _resolveComponent("Dropdown1")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_AgroBreadcrumbs = _resolveComponent("AgroBreadcrumbs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isButtonBack)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: {
              name: _ctx.backPageName,
            },
                title: "Вернуться",
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.getCurrentRouteName), 1),
          (_ctx.createNewPageEnabled)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: {
              name: _ctx.createPageName,
            },
                title: "Создать",
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, [
                _createElementVNode("img", {
                  src: _ctx.setHost('media/icons/duotone/General/User.svg'),
                  alt: "Меню"
                }, null, 8, _hoisted_12)
              ])
            ]),
            _createVNode(_component_Dropdown1)
          ]),
          (_ctx.asideEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(_component_inline_svg, {
                    src: _ctx.setHost('media/icons/duotone/Text/Menu.svg')
                  }, null, 8, ["src"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      false
        ? (_openBlock(), _createBlock(_component_AgroBreadcrumbs, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}